// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sq-settings-tabs {
  margin-bottom: 1rem;
  border-bottom: 1px solid var(--sq-border);
}

.sq-settings-panel {
  max-width: 44rem;
}
.sq-settings-panel p {
  font-size: 0.875rem;
  color: var(--sq-text-2);
}
.sq-settings-panel code {
  overflow-wrap: anywhere;
}

.sq-sync {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.625rem 0.75rem;
  margin-top: 0.875rem;
}
.sq-sync .sq-muted {
  flex: 1 1 14rem;
}

.sq-discord-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 0.75rem 1rem;
  padding: 0.875rem 0;
  border-top: 1px solid var(--sq-border);
}
.sq-discord-row > div {
  flex: 1 1 16rem;
  min-width: 0;
}
.sq-discord-row .btn,
.sq-discord-row .MuiButton-root {
  min-width: 7.5rem;
}`, "",{"version":3,"sources":["webpack://./src/components/setting/setting.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,yCAAA;AACF;;AAGA;EACE,gBAAA;AAAF;AAEE;EACE,mBAAA;EACA,uBAAA;AAAJ;AAGE;EACE,uBAAA;AADJ;;AAKA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,qBAAA;EACA,oBAAA;AAFF;AAIE;EACE,eAAA;AAFJ;;AAMA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,sCAAA;AAHF;AAKE;EACE,eAAA;EACA,YAAA;AAHJ;AAME;;EAEE,iBAAA;AAJJ","sourcesContent":[".sq-settings-tabs {\n  margin-bottom: 1rem;\n  border-bottom: 1px solid var(--sq-border);\n}\n\n// Integration panels: one readable column, not a full-width form.\n.sq-settings-panel {\n  max-width: 44rem;\n\n  p {\n    font-size: 0.875rem;\n    color: var(--sq-text-2);\n  }\n\n  code {\n    overflow-wrap: anywhere;\n  }\n}\n\n.sq-sync {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.625rem 0.75rem;\n  margin-top: 0.875rem;\n\n  .sq-muted {\n    flex: 1 1 14rem;\n  }\n}\n\n.sq-discord-row {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 0.75rem 1rem;\n  padding: 0.875rem 0;\n  border-top: 1px solid var(--sq-border);\n\n  > div {\n    flex: 1 1 16rem;\n    min-width: 0;\n  }\n\n  .btn,\n  .MuiButton-root {\n    min-width: 7.5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
